import React, { createContext, useContext } from 'react';
import { USER_STATES } from '../utils/constants';
import { IAppContext } from './AppContext.interface';

const noop = () => {};

// TODO refactor initialization here
const defaultAppContextValue: IAppContext = {
  brandsAndOutlets: null,
  iusAndOutlets: null,
  sbPayBrandsAndOutlets: null,
  productSubByBrand: null,
  filterValues: {
    brands: null,
    outlets: null,
    dateRange: null,
    inventory: undefined,
    transactionSearch: null,
    unit: undefined,
    opportunity: undefined,
  },
  setFilterValues: noop,
  setSbPayBrandsAndOutlets: noop,
  // biome-ignore lint/suspicious/noExplicitAny: Existing API type requires any.
  getFilterValues: (options: any) => {},
  setUser: noop,
  user: USER_STATES.NOT_AUTHENTICATED,
  initUserEnv: noop,
  resetFilterValues: noop,
};
const AppContext = createContext(defaultAppContextValue);

export const useAppContext = () => useContext(AppContext);

// biome-ignore lint/suspicious/noExplicitAny: Existing API type requires any.
const withAppContext = (ChildComponent: any) => (props: any) => {
  const appContext = useContext(AppContext);
  return <ChildComponent {...props} appContext={appContext} />;
};

export { AppContext as default, withAppContext };
